import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/lp-game.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/leadpops-mortgage-marketing-logo.webp");
;
import(/* webpackMode: "eager", webpackExports: ["LPMagnetMount"] */ "/vercel/path0/src/components/v2/LPMagnetMount.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPThemeToggle"] */ "/vercel/path0/src/components/v2/LPThemeToggle.tsx");
